import React, { type FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

import { messages as meetingNotesMessages } from '../i18n/meeting-notes-messages.ts';
import { messages } from '../i18n/messages.ts';

import { tagBackgroundColors, tagBorderColors, templateStyles } from './styles.ts';

const MeetingNotes: FunctionComponent = () => {
  const { formatMessage } = useIntl();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={348} height={142} fill="none">
      <rect width={336} height={141.98} fill={templateStyles['background']} rx={3} />
      <mask id="meetingNotes-a" fill="#fff">
        <path d="M320 0h13a3 3 0 0 1 3 3v13h-16V0Z" />
      </mask>
      <path fill={templateStyles['background']} d="M320 0h13a3 3 0 0 1 3 3v13h-16V0Z" />
      <path
        fill={templateStyles['border']}
        d="M320 0h16-16Zm16 16h-16 16Zm-16.31 0V0h.62v16h-.62ZM336 0v16V0Z"
        mask="url(#meetingNotes-a)"
      />
      <path fill="#fff" fillOpacity={0.01} d="M324.27 4.27h7.47v7.47h-7.47z" />
      <path
        fill={templateStyles['icon']}
        d="M328 5.51c.16 0 .3.12.3.28l.01.03V7.7h1.87a.31.31 0 0 1 .03.62h-1.9v1.87a.31.31 0 0 1-.62.03V8.31h-1.87a.31.31 0 0 1-.03-.62h1.9V5.82c0-.17.14-.3.31-.3Z"
      />
      <mask id="meetingNotes-b" fill="#fff">
        <path d="M0 3a3 3 0 0 1 3-3h53v16H0V3Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M-.31 3a3.31 3.31 0 0 1 3.3-3.31h53.32l-.62.62H3A2.69 2.69 0 0 0 .31 3H-.3ZM56.3 16.31H-.3l.62-.62H55.7l.62.62Zm-56.62 0V3a3.31 3.31 0 0 1 3.3-3.31L3 .31A2.69 2.69 0 0 0 .31 3v12.69l-.62.62ZM56.3-.31v16.62l-.62-.62V.31l.62-.62Z"
        mask="url(#meetingNotes-b)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M9.64 6.6H5.3v-.47h4.35v.47Zm0 1.63H5.3v-.46h4.35v.46ZM7.47 9.87H5.29V9.4h2.18v.47Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        fontWeight="bold"
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={12.44} y={9.16}>
          {formatMessage(meetingNotesMessages['meeting-notes.field-1-name'])}
        </tspan>
      </text>
      <mask id="meetingNotes-c" fill="#fff">
        <path d="M0 16h56v36.66H0V16Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M56 52.66v.31h.31v-.31H56Zm-56 0h-.31v.31H0v-.31ZM55.69 16v36.66h.62V16h-.62ZM56 52.35H0v.62h56v-.62Zm-55.69.31V16H-.3v36.66h.6Z"
        mask="url(#meetingNotes-c)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={4} y={24.66}>
          {formatMessage(meetingNotesMessages['meeting-notes.entry-1-cell-1'])}
        </tspan>
      </text>
      <mask id="meetingNotes-d" fill="#fff">
        <path d="M0 52.66h56v36.66H0V52.66Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M56 89.32v.31h.31v-.31H56Zm-56 0h-.31v.31H0v-.31Zm55.69-36.66v36.66h.62V52.66h-.62ZM56 89.01H0v.62h56v-.62Zm-55.69.31V52.66H-.3v36.66h.6Z"
        mask="url(#meetingNotes-d)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={4} y={61.32}>
          {formatMessage(meetingNotesMessages['meeting-notes.entry-2-cell-1'])}
        </tspan>
      </text>
      <mask id="meetingNotes-e" fill="#fff">
        <path d="M0 89.32h56v36.66H0V89.32Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M56 125.98v.31h.31v-.31H56Zm-56 0h-.31v.31H0v-.31Zm55.69-36.66v36.66h.62V89.32h-.62Zm.31 36.35H0v.62h56v-.62Zm-55.69.31V89.32H-.3v36.66h.6Z"
        mask="url(#meetingNotes-e)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={4} y={97.98}>
          {formatMessage(meetingNotesMessages['meeting-notes.entry-3-cell-1'])}
        </tspan>
      </text>
      <mask id="meetingNotes-f" fill="#fff">
        <path d="M0 125.98h336v13a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-13Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M0 125.98h336H0Zm336.31 13a3.31 3.31 0 0 1-3.31 3.31H3a3.31 3.31 0 0 1-3.31-3.31H.3c0 1.49 1.2 2.69 2.69 2.69h330c1.49 0 2.69-1.2 2.69-2.69h.62ZM3 142.29a3.31 3.31 0 0 1-3.31-3.31v-13H.3v13c0 1.49 1.2 2.69 2.69 2.69v.62Zm333.31-16.31v13a3.31 3.31 0 0 1-3.31 3.31v-.62c1.49 0 2.69-1.2 2.69-2.69v-13h.62Z"
        mask="url(#meetingNotes-f)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M6.57 132.67a.26.26 0 0 0-.52 0v1.05H4.99a.26.26 0 0 0 0 .52h1.06v1.05a.26.26 0 0 0 .52 0v-1.05h1.05a.26.26 0 0 0 0-.52H6.57v-1.05Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={3.68}
        letterSpacing={-0.02}
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={10.51} y={135.29}>
          {formatMessage(messages['templates-preview.add-entry'])}
        </tspan>
      </text>
      <mask id="meetingNotes-g" fill="#fff">
        <path d="M56 0h56v16H56V0Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M112 0h.31v-.31H112V0Zm0 16v.31h.31V16H112ZM56 0v.31h56v-.62H56V0Zm56 0h-.31v16h.62V0H112Zm0 16v-.31H56v.62h56V16Z"
        mask="url(#meetingNotes-g)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M63.27 6a.62.62 0 0 1 .44-.18h1.31c.35 0 .63.28.63.62v1.32c0 .17-.07.32-.19.44L63.67 10a.62.62 0 0 1-.88 0l-1.31-1.32a.62.62 0 0 1 0-.88L63.27 6Zm.44.29a.16.16 0 0 0-.11.04l-1.8 1.8a.16.16 0 0 0 0 .21l1.32 1.32c.07.06.16.06.22 0l1.8-1.79a.16.16 0 0 0 .04-.1V6.43a.16.16 0 0 0-.16-.15h-1.31Z"
        clipRule="evenodd"
      />
      <path
        fill={templateStyles['icon']}
        d="M64.09 7.07a.31.31 0 1 1 .62 0 .31.31 0 0 1-.62 0Z"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        fontWeight="bold"
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={68.45} y={9.16}>
          {formatMessage(meetingNotesMessages['meeting-notes.field-2-name'])}
        </tspan>
      </text>
      <mask id="meetingNotes-h" fill="#fff">
        <path d="M56 16h56v36.66H56V16Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M112 52.66v.31h.31v-.31H112ZM111.69 16v36.66h.62V16h-.62Zm.31 36.35H56v.62h56v-.62Z"
        mask="url(#meetingNotes-h)"
      />
      <mask id="meetingNotes-i" fill="#fff">
        <path d="M60 20.93c0-.51.42-.93.93-.93h23.63c.51 0 .93.42.93.93v4.36c0 .51-.42.93-.93.93H60.93a.93.93 0 0 1-.93-.93v-4.36Z" />
      </mask>
      <path
        fill={tagBackgroundColors['orangeLight']}
        d="M60 20.93c0-.51.42-.93.93-.93h23.63c.51 0 .93.42.93.93v4.36c0 .51-.42.93-.93.93H60.93a.93.93 0 0 1-.93-.93v-4.36Z"
      />
      <path
        fill={tagBorderColors['orangeLight']}
        d="M60.93 20.31h23.63v-.62H60.93v.62Zm24.25.62v4.36h.62v-4.36h-.62Zm-.62 4.98H60.93v.62h23.63v-.62ZM60.3 25.3v-4.36h-.62v4.36h.62Zm.62.62a.62.62 0 0 1-.62-.62h-.62c0 .69.56 1.24 1.24 1.24v-.62Zm24.25-.62c0 .34-.28.62-.62.62v.62c.68 0 1.24-.55 1.24-1.24h-.62Zm-.62-4.98c.34 0 .62.28.62.62h.62c0-.68-.56-1.24-1.24-1.24v.62Zm-23.63-.62c-.68 0-1.24.56-1.24 1.24h.62c0-.34.28-.62.62-.62v-.62Z"
        mask="url(#meetingNotes-i)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={61.26} y={24.27}>
          {formatMessage(meetingNotesMessages['meeting-notes.field-2-select-option-1'])}
        </tspan>
      </text>
      <mask id="meetingNotes-j" fill="#fff">
        <path d="M60 28.16c0-.52.42-.94.93-.94h25.63c.51 0 .93.42.93.94v4.35c0 .52-.42.93-.93.93H60.93a.93.93 0 0 1-.93-.93v-4.35Z" />
      </mask>
      <path
        fill={tagBackgroundColors['redLight']}
        d="M60 28.16c0-.52.42-.94.93-.94h25.63c.51 0 .93.42.93.94v4.35c0 .52-.42.93-.93.93H60.93a.93.93 0 0 1-.93-.93v-4.35Z"
      />
      <path
        fill={tagBorderColors['redLight']}
        d="M60.93 27.22v.31h25.63v-.62H60.93v.31Zm26.56.94h-.31v4.35h.62v-4.35h-.31Zm-.93 5.28v-.3H60.93v.62h25.63v-.32ZM60 32.51h.31v-4.35h-.62v4.35H60Zm.93.93v-.3a.62.62 0 0 1-.62-.63h-.62c0 .69.56 1.25 1.24 1.25v-.32Zm26.56-.93h-.31c0 .34-.28.62-.62.62v.63c.68 0 1.24-.56 1.24-1.25h-.31Zm-.93-5.29v.31c.34 0 .62.28.62.63h.62c0-.7-.56-1.25-1.24-1.25v.31Zm-25.63 0v-.3c-.68 0-1.24.55-1.24 1.24h.62c0-.35.28-.63.62-.63v-.3Z"
        mask="url(#meetingNotes-j)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={61} y={31.49}>
          {formatMessage(meetingNotesMessages['meeting-notes.field-2-select-option-2'])}
        </tspan>
      </text>
      <mask id="meetingNotes-k" fill="#fff">
        <path d="M88.49 28.16c0-.52.42-.94.93-.94h13.62c.52 0 .94.42.94.94v4.35c0 .52-.42.93-.94.93H89.42a.93.93 0 0 1-.93-.93v-4.35Z" />
      </mask>
      <path
        fill={tagBackgroundColors['blueLight']}
        d="M88.49 28.16c0-.52.42-.94.93-.94h13.62c.52 0 .94.42.94.94v4.35c0 .52-.42.93-.94.93H89.42a.93.93 0 0 1-.93-.93v-4.35Z"
      />
      <path
        fill={tagBorderColors['blueLight']}
        d="M89.42 27.22v.31h13.62v-.62H89.42v.31Zm14.56.94h-.31v4.35h.62v-4.35h-.31Zm-.94 5.28v-.3H89.42v.62h13.62v-.32Zm-14.55-.93h.31v-4.35h-.62v4.35h.3Zm.93.93v-.3a.62.62 0 0 1-.62-.63h-.62c0 .69.55 1.25 1.24 1.25v-.32Zm14.56-.93h-.31c0 .34-.28.62-.63.62v.63c.7 0 1.25-.56 1.25-1.25h-.31Zm-.94-5.29v.31c.35 0 .63.28.63.63h.62c0-.7-.56-1.25-1.25-1.25v.31Zm-13.62 0v-.3c-.69 0-1.24.55-1.24 1.24h.62c0-.35.28-.63.62-.63v-.3Z"
        mask="url(#meetingNotes-k)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={89.77} y={31.49}>
          {formatMessage(meetingNotesMessages['meeting-notes.field-2-select-option-3'])}
        </tspan>
      </text>
      <mask id="meetingNotes-l" fill="#fff">
        <path d="M56 52.66h56v36.66H56V52.66Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M112 89.32v.31h.31v-.31H112Zm-.31-36.66v36.66h.62V52.66h-.62Zm.31 36.35H56v.62h56v-.62Z"
        mask="url(#meetingNotes-l)"
      />
      <rect
        width={23.7}
        height={5.92}
        x={60.15}
        y={56.81}
        fill={tagBackgroundColors['yellowLight']}
        rx={0.78}
      />
      <rect
        width={23.7}
        height={5.92}
        x={60.15}
        y={56.81}
        stroke={tagBorderColors['yellowLight']}
        strokeWidth={0.3}
        rx={0.78}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={62.21} y={61.32}>
          {formatMessage(meetingNotesMessages['meeting-notes.field-2-select-option-4'])}
        </tspan>
      </text>
      <rect
        width={20.7}
        height={5.92}
        x={85.39}
        y={56.81}
        fill={tagBackgroundColors['purpleLight']}
        rx={0.78}
      />
      <rect
        width={20.7}
        height={5.92}
        x={85.39}
        y={56.81}
        stroke={tagBorderColors['purpleLight']}
        strokeWidth={0.3}
        rx={0.78}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={87.54} y={61.32}>
          {formatMessage(meetingNotesMessages['meeting-notes.field-2-select-option-5'])}
        </tspan>
      </text>
      <mask id="meetingNotes-m" fill="#fff">
        <path d="M56 89.32h56v36.66H56V89.32Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M112 125.98v.31h.31v-.31H112Zm-.31-36.66v36.66h.62V89.32h-.62Zm.31 36.35H56v.62h56v-.62Z"
        mask="url(#meetingNotes-m)"
      />
      <rect
        width={18.7}
        height={5.92}
        x={60.15}
        y={93.47}
        fill={tagBackgroundColors['limeLight']}
        rx={0.78}
      />
      <rect
        width={18.7}
        height={5.92}
        x={60.15}
        y={93.47}
        stroke={tagBorderColors['limeLight']}
        strokeWidth={0.3}
        rx={0.78}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={62.39} y={97.98}>
          {formatMessage(meetingNotesMessages['meeting-notes.field-2-select-option-6'])}
        </tspan>
      </text>
      <rect
        width={20.7}
        height={5.92}
        x={80.39}
        y={93.47}
        fill={tagBackgroundColors['greyLight']}
        rx={0.78}
      />
      <rect
        width={20.7}
        height={5.92}
        x={80.39}
        y={93.47}
        stroke={tagBorderColors['greyLight']}
        strokeWidth={0.3}
        rx={0.78}
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={82.54} y={97.98}>
          {formatMessage(meetingNotesMessages['meeting-notes.field-2-select-option-7'])}
        </tspan>
      </text>
      <mask id="meetingNotes-n" fill="#fff">
        <path d="M112 0h56v16h-56V0Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M168 0h.31v-.31H168V0Zm0 16v.31h.31V16H168ZM112 0v.31h56v-.62h-56V0Zm56 0h-.31v16h.62V0H168Zm0 16v-.31h-56v.62h56V16Z"
        mask="url(#meetingNotes-n)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M118.38 6.29v.62h.47V6.3h1.24v.62h.47V6.3h.46c.09 0 .16.07.16.15v.94h-3.42v-.94c0-.08.07-.15.15-.15h.47Zm-.62 1.55v1.72c0 .08.07.15.15.15h3.11c.09 0 .16-.07.16-.15V7.84h-3.42Zm2.8-2.02h.46c.35 0 .63.28.63.62v3.12c0 .34-.28.62-.63.62h-3.1a.62.62 0 0 1-.63-.62V6.44c0-.34.28-.62.62-.62h.47v-.3h.47v.3h1.24v-.3h.47v.3Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        fontWeight="bold"
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={124.45} y={9.16}>
          {formatMessage(meetingNotesMessages['meeting-notes.field-3-name'])}
        </tspan>
      </text>
      <mask id="meetingNotes-o" fill="#fff">
        <path d="M112 16h56v36.66h-56V16Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M168 52.66v.31h.31v-.31H168ZM167.69 16v36.66h.62V16h-.62Zm.31 36.35h-56v.62h56v-.62Z"
        mask="url(#meetingNotes-o)"
      />
      <rect
        width={26.49}
        height={8.24}
        x={116}
        y={20}
        fill={templateStyles['userBackground']}
        rx={0.93}
      />
      <path
        fill={templateStyles['fontColor']}
        d="M118.3 25.7c-.14 0-.26-.02-.36-.06a.75.75 0 0 1-.44-.4.92.92 0 0 1-.07-.32v-.03h.38v.03c.01.07.03.14.07.2.04.07.09.12.16.16a.5.5 0 0 0 .25.06c.17 0 .3-.05.39-.15.09-.1.13-.24.13-.42v-2.22h.39v2.22c0 .2-.04.36-.11.5a.74.74 0 0 1-.31.31 1 1 0 0 1-.49.11Zm2.4-.04a.89.89 0 0 1-.44-.1.63.63 0 0 1-.26-.28 1.1 1.1 0 0 1-.09-.47v-1.48h.37v1.4c0 .2.04.35.12.45.08.1.21.16.4.16.1 0 .19-.02.26-.05a.53.53 0 0 0 .2-.13c.05-.05.09-.12.11-.2a.86.86 0 0 0 .05-.27v-1.36h.36v2.3h-.36v-.35h-.04a.63.63 0 0 1-.15.2.65.65 0 0 1-.23.14.93.93 0 0 1-.3.04Zm1.78-.04v-2.29h.37v.34h.03a.65.65 0 0 1 .25-.28c.11-.07.25-.1.42-.1.26 0 .45.07.6.22.13.15.2.36.2.63v1.48h-.37v-1.4c0-.2-.04-.35-.13-.45-.09-.1-.22-.15-.4-.15a.61.61 0 0 0-.32.08.53.53 0 0 0-.21.22.76.76 0 0 0-.07.35v1.35h-.37Zm4.51 0v-2.64h-.03l-.78.56v-.4l.82-.59h.38v3.07h-.39Zm1.08.78.18-1.2h.42l-.33 1.2h-.28Zm2.6-.78v-.26l1.04-1.12c.13-.15.23-.26.3-.36.08-.09.13-.17.16-.25a.66.66 0 0 0 .05-.25.6.6 0 0 0-.07-.29.52.52 0 0 0-.2-.2.62.62 0 0 0-.31-.08.65.65 0 0 0-.32.08.53.53 0 0 0-.22.21.62.62 0 0 0-.07.32h-.37a.9.9 0 0 1 .49-.81c.14-.09.32-.13.51-.13.18 0 .34.04.49.11.14.08.25.18.34.3a.8.8 0 0 1 .12.45c0 .12-.02.23-.06.34-.04.1-.11.23-.21.36-.1.13-.25.3-.44.48l-.79.82.1-.18v.18l-.1-.06h1.55v.34h-1.98Zm3.66.07a.9.9 0 0 1-.58-.2 1.23 1.23 0 0 1-.37-.55 2.52 2.52 0 0 1-.13-.85c0-.33.04-.62.13-.86.08-.24.2-.42.37-.55a.9.9 0 0 1 .58-.2.9.9 0 0 1 .58.2c.16.13.29.31.38.55.08.24.13.53.13.85 0 .34-.05.62-.13.86-.1.24-.22.43-.38.56a.9.9 0 0 1-.58.2Zm0-.33c.15 0 .27-.05.38-.15a1 1 0 0 0 .24-.44c.05-.2.08-.42.08-.68 0-.27-.03-.5-.08-.68a.98.98 0 0 0-.24-.44.51.51 0 0 0-.38-.15.52.52 0 0 0-.38.15 1 1 0 0 0-.23.44c-.06.19-.09.41-.09.67 0 .27.03.5.09.69.05.19.13.33.23.44.1.1.24.15.38.15Zm1.72.26v-.26l1.03-1.12c.13-.15.24-.26.31-.36.08-.09.13-.17.16-.25a.66.66 0 0 0 .04-.25c0-.1-.02-.2-.07-.29a.52.52 0 0 0-.2-.2.62.62 0 0 0-.31-.08.65.65 0 0 0-.32.08.53.53 0 0 0-.22.21.62.62 0 0 0-.07.32h-.37a.9.9 0 0 1 .48-.82c.16-.08.33-.12.53-.12.18 0 .34.04.48.11.14.08.25.18.34.3a.8.8 0 0 1 .12.45c0 .12-.02.23-.06.34-.04.1-.11.23-.21.36-.1.13-.25.3-.43.48l-.8.82.1-.18v.18l-.1-.06h1.55v.34h-1.98Zm3.63.07a.97.97 0 0 1-.87-.42.92.92 0 0 1-.15-.43v-.03h.36v.02a.57.57 0 0 0 .34.46c.1.04.2.07.33.07a.7.7 0 0 0 .36-.1c.1-.05.18-.14.24-.24.06-.11.09-.23.09-.37a.72.72 0 0 0-.1-.37.64.64 0 0 0-.23-.24.69.69 0 0 0-.36-.1c-.1 0-.2.02-.28.05a.67.67 0 0 0-.37.33h-.33l.16-1.77h1.71v.35h-1.4l-.1 1.03h.02c.05-.07.1-.12.17-.17a.9.9 0 0 1 .49-.14.94.94 0 0 1 .86.5c.09.15.13.32.13.52s-.04.4-.14.55a.98.98 0 0 1-.37.37c-.16.09-.35.13-.56.13Z"
      />

      <mask id="meetingNotes-p" fill="#fff">
        <path d="M112 52.66h56v36.66h-56V52.66Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M168 89.32v.31h.31v-.31H168Zm-.31-36.66v36.66h.62V52.66h-.62Zm.31 36.35h-56v.62h56v-.62Z"
        mask="url(#meetingNotes-p)"
      />
      <rect
        width={30.49}
        height={8.24}
        x={116}
        y={56.66}
        fill={templateStyles['userBackground']}
        rx={0.93}
      />
      <path
        fill={templateStyles['fontColor']}
        d="m117.4 62.28 1.12-3.07h.3v.5h-.13l-.9 2.57h-.4Zm.5-.88.12-.32h1.39l.12.32h-1.63Zm1.73.88-.9-2.57v-.5h.17l1.13 3.07h-.4Zm1.56.04a.89.89 0 0 1-.44-.1.63.63 0 0 1-.27-.28 1.1 1.1 0 0 1-.08-.47V60h.37v1.4c0 .2.04.35.12.45.08.1.2.16.4.16.1 0 .18-.02.26-.05a.53.53 0 0 0 .2-.13c.05-.05.08-.12.11-.2a.89.89 0 0 0 .04-.27v-1.36h.37v2.3h-.37v-.35h-.03a.63.63 0 0 1-.16.2.65.65 0 0 1-.22.14.94.94 0 0 1-.3.04Zm2.72.77c-.19 0-.35-.03-.49-.08a.78.78 0 0 1-.33-.22.65.65 0 0 1-.15-.32h.39c.02.08.08.15.18.2.1.06.23.1.4.1.2 0 .36-.05.48-.15.11-.09.17-.22.17-.39v-.46h-.03a.78.78 0 0 1-.72.4.93.93 0 0 1-.52-.15.94.94 0 0 1-.33-.39 1.32 1.32 0 0 1-.11-.57c0-.22.04-.4.11-.57.08-.17.2-.3.34-.4.14-.1.32-.14.52-.14.1 0 .2.02.3.05a.8.8 0 0 1 .42.37h.02v-.38h.37v2.26a.8.8 0 0 1-.13.44.8.8 0 0 1-.35.3c-.16.07-.34.1-.55.1Zm-.02-1.25c.14 0 .26-.04.36-.1.1-.07.18-.16.24-.28a.93.93 0 0 0 .08-.4.94.94 0 0 0-.08-.4.64.64 0 0 0-.24-.28.64.64 0 0 0-.36-.1.63.63 0 0 0-.36.1.65.65 0 0 0-.23.27 1 1 0 0 0-.08.4v.01a1 1 0 0 0 .08.4c.05.12.13.21.23.28.1.06.22.1.36.1Zm2.95.44v-.26l1.04-1.12c.13-.15.23-.26.3-.36.08-.09.13-.17.16-.25a.68.68 0 0 0 .04-.25c0-.1-.02-.2-.07-.29a.51.51 0 0 0-.2-.2.61.61 0 0 0-.3-.08.66.66 0 0 0-.33.08.53.53 0 0 0-.21.21.62.62 0 0 0-.08.32h-.37a.9.9 0 0 1 .49-.82c.15-.08.32-.12.52-.12.18 0 .34.04.48.11.14.08.26.18.34.3a.8.8 0 0 1 .12.45c0 .12-.02.23-.06.34-.04.1-.1.23-.21.36-.1.13-.25.3-.43.48l-.8.82.1-.17V62l-.1-.06h1.55v.34h-1.98Zm3.65.07a.9.9 0 0 1-.58-.2 1.24 1.24 0 0 1-.37-.55 2.55 2.55 0 0 1-.13-.85c0-.33.05-.62.13-.86.09-.24.21-.42.37-.55a.9.9 0 0 1 .58-.2.9.9 0 0 1 .59.2c.16.13.28.31.37.55.09.24.13.53.13.85 0 .34-.04.62-.13.86s-.21.43-.37.56a.9.9 0 0 1-.59.2Zm0-.33c.15 0 .28-.05.38-.15a1 1 0 0 0 .24-.44c.06-.2.09-.42.09-.68 0-.27-.03-.5-.09-.68a.99.99 0 0 0-.24-.44.51.51 0 0 0-.38-.15.52.52 0 0 0-.37.15 1 1 0 0 0-.24.44c-.06.19-.08.41-.08.67 0 .27.02.5.08.69.06.19.13.33.24.44.1.1.23.15.37.15Zm1.46 1.04.18-1.2h.43l-.34 1.2h-.27Zm2.6-.78v-.26l1.05-1.12c.13-.15.23-.26.3-.36.08-.09.13-.17.16-.25a.68.68 0 0 0 .04-.25c0-.1-.02-.2-.07-.29a.51.51 0 0 0-.2-.2.61.61 0 0 0-.3-.08.65.65 0 0 0-.33.08.52.52 0 0 0-.21.21.62.62 0 0 0-.08.32h-.37a.9.9 0 0 1 .49-.82c.15-.08.32-.12.52-.12.18 0 .34.04.48.11.14.08.26.18.34.3a.8.8 0 0 1 .12.45c0 .12-.02.23-.06.34-.04.1-.1.23-.21.36-.1.13-.25.3-.43.48l-.8.82.1-.17V62l-.1-.06h1.55v.34h-1.98Zm3.66.07a.9.9 0 0 1-.58-.2 1.24 1.24 0 0 1-.37-.55 2.55 2.55 0 0 1-.13-.85c0-.33.05-.62.13-.86.09-.24.21-.42.37-.55a.9.9 0 0 1 .58-.2.9.9 0 0 1 .59.2c.16.13.28.31.37.55.09.24.13.53.13.85 0 .34-.04.62-.13.86s-.21.43-.37.56a.9.9 0 0 1-.59.2Zm0-.33c.15 0 .28-.05.38-.15a1 1 0 0 0 .24-.44c.06-.2.09-.42.09-.68 0-.27-.03-.5-.09-.68a.99.99 0 0 0-.24-.44.51.51 0 0 0-.38-.15.52.52 0 0 0-.37.15 1 1 0 0 0-.24.44c-.06.19-.08.41-.08.67 0 .27.02.5.08.69.06.19.13.33.24.44.1.1.23.15.37.15Zm1.72.26v-.26l1.04-1.12c.13-.15.23-.26.3-.36.08-.09.13-.17.16-.25a.66.66 0 0 0 .04-.25c0-.1-.02-.2-.07-.29a.51.51 0 0 0-.2-.2.61.61 0 0 0-.3-.08.65.65 0 0 0-.33.08.53.53 0 0 0-.21.21.62.62 0 0 0-.08.32h-.37a.9.9 0 0 1 .49-.81c.15-.09.32-.13.52-.13.18 0 .34.04.48.11.14.08.26.18.34.3a.8.8 0 0 1 .13.45c0 .12-.03.23-.07.34-.04.1-.1.23-.2.36-.11.13-.25.3-.44.48l-.8.82.1-.17V62l-.1-.06h1.56v.34h-1.99Zm3.64.07c-.2 0-.36-.03-.51-.1a.96.96 0 0 1-.36-.31.93.93 0 0 1-.16-.44v-.03h.37v.02a.58.58 0 0 0 .34.46c.1.04.2.07.32.07.14 0 .26-.03.36-.1.1-.05.19-.14.24-.24.06-.11.09-.23.09-.37a.71.71 0 0 0-.09-.37.63.63 0 0 0-.24-.24.69.69 0 0 0-.35-.1c-.1 0-.2.02-.29.05a.67.67 0 0 0-.36.33h-.34l.17-1.77h1.7v.35h-1.4l-.1 1.03h.03a.75.75 0 0 1 .4-.28.97.97 0 0 1 1.13.46c.07.16.12.33.12.53 0 .21-.05.4-.14.55a.98.98 0 0 1-.38.37c-.16.09-.34.13-.55.13Z"
      />
      <mask id="meetingNotes-q" fill="#fff">
        <path d="M112 89.32h56v36.66h-56V89.32Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M168 125.98v.31h.31v-.31H168Zm-.31-36.66v36.66h.62V89.32h-.62Zm.31 36.35h-56v.62h56v-.62Z"
        mask="url(#meetingNotes-q)"
      />
      <rect
        width={30.49}
        height={8.24}
        x={116}
        y={93.32}
        fill={templateStyles['userBackground']}
        rx={0.93}
      />
      <path
        fill={templateStyles['fontColor']}
        d="M117.64 98.94v-3.07h.37l1.76 2.53-.26-.14h.2v-2.39h.38v3.07h-.38l-1.75-2.51.25.13h-.2v2.38h-.37Zm4.12.04c-.21 0-.4-.05-.56-.14a.97.97 0 0 1-.37-.41 1.45 1.45 0 0 1-.12-.63c0-.25.04-.46.12-.64a.96.96 0 0 1 .93-.55c.22 0 .41.05.57.14.16.1.28.23.36.41.09.18.13.39.13.63 0 .25-.04.46-.13.64a.95.95 0 0 1-.93.55Zm0-.33c.15 0 .27-.03.37-.1.1-.07.18-.16.23-.29.06-.13.08-.28.08-.46 0-.19-.02-.34-.08-.47a.62.62 0 0 0-.23-.3.64.64 0 0 0-.37-.1.64.64 0 0 0-.36.1.63.63 0 0 0-.24.3c-.05.13-.08.28-.08.46 0 .19.03.34.08.47.06.13.14.22.24.3.1.06.22.1.36.1Zm2.2.3-.85-2.3h.4l.62 1.89h.03l.63-1.9h.4l-.86 2.3h-.37Zm3.68 0V96.3h-.03l-.78.56v-.4l.82-.59h.38v3.07h-.39Zm2.67 0v-.64h-1.49v-.35a69.73 69.73 0 0 1 .52-.85l.26-.43a56.74 56.74 0 0 1 .53-.8h.56v2.08h.44v.35h-.44v.63h-.38Zm-1.1-.98h1.1v-1.74h-.02l-.21.32-.22.34-.22.35a33.85 33.85 0 0 0-.43.7v.03Zm2.27 1.75.18-1.2h.43l-.34 1.2h-.27Zm2.6-.78v-.26l1.04-1.12c.13-.15.24-.26.31-.36.07-.09.13-.17.16-.25a.66.66 0 0 0 .04-.25c0-.1-.02-.2-.07-.29a.52.52 0 0 0-.2-.2.61.61 0 0 0-.31-.08.66.66 0 0 0-.32.08.53.53 0 0 0-.22.21.62.62 0 0 0-.07.32h-.37a.9.9 0 0 1 .48-.82c.16-.08.33-.12.52-.12.18 0 .34.04.49.11.14.08.25.18.34.3a.8.8 0 0 1 .12.45c0 .12-.02.23-.06.34-.04.1-.11.23-.21.36-.1.13-.25.3-.44.48l-.79.82.1-.18v.18l-.1-.06h1.55v.34h-1.98Zm3.66.07a.9.9 0 0 1-.58-.2 1.24 1.24 0 0 1-.37-.55 2.55 2.55 0 0 1-.13-.85c0-.33.04-.62.13-.86s.2-.42.37-.55a.9.9 0 0 1 .58-.2.9.9 0 0 1 .58.2c.17.13.29.31.38.55.09.24.13.53.13.85 0 .34-.05.62-.13.86-.09.24-.21.43-.38.56a.9.9 0 0 1-.58.2Zm0-.33c.15 0 .27-.05.38-.15a1 1 0 0 0 .24-.44c.05-.2.08-.42.08-.68 0-.27-.03-.5-.08-.68a.99.99 0 0 0-.24-.44.51.51 0 0 0-.38-.15.51.51 0 0 0-.37.15 1 1 0 0 0-.24.44c-.06.19-.09.41-.09.67 0 .27.03.5.09.69.05.19.13.33.24.44.1.1.23.15.37.15Zm1.72.26v-.26l1.04-1.12c.13-.15.23-.26.3-.36.08-.09.13-.17.16-.25a.68.68 0 0 0 .04-.25c0-.1-.02-.2-.07-.29a.52.52 0 0 0-.2-.2.61.61 0 0 0-.3-.08.65.65 0 0 0-.33.08.52.52 0 0 0-.21.21.62.62 0 0 0-.08.32h-.37a.9.9 0 0 1 .49-.82c.15-.08.32-.12.52-.12.18 0 .34.04.48.11.14.08.26.18.34.3a.8.8 0 0 1 .12.45c0 .12-.02.23-.06.34-.04.1-.1.23-.21.36-.1.13-.25.3-.43.48l-.8.82.1-.18v.18l-.1-.06h1.56v.34h-2Zm3.63.07a.96.96 0 0 1-.87-.42.92.92 0 0 1-.15-.43v-.03h.37v.02a.58.58 0 0 0 .34.46c.1.04.2.07.32.07.14 0 .25-.03.36-.1.1-.05.18-.14.24-.24.06-.11.09-.23.09-.37a.72.72 0 0 0-.1-.37.63.63 0 0 0-.23-.24.69.69 0 0 0-.35-.1c-.1 0-.2.02-.29.05a.67.67 0 0 0-.36.33h-.34l.16-1.77H144v.35h-1.4l-.1 1.03h.03c.04-.07.1-.12.16-.17a.9.9 0 0 1 .49-.14.94.94 0 0 1 .86.5c.09.15.13.32.13.52s-.04.4-.14.55a.97.97 0 0 1-.37.37c-.16.09-.35.13-.56.13Z"
      />
      <mask id="meetingNotes-r" fill="#fff">
        <path d="M168 0h56v16h-56V0Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M224 0h.31v-.31H224V0Zm0 16v.31h.31V16H224ZM168 0v.31h56v-.62h-56V0Zm56 0h-.31v16h.62V0H224Zm0 16v-.31h-56v.62h56V16Z"
        mask="url(#meetingNotes-r)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M177.65 6.6h-4.36v-.47h4.36v.47Zm0 1.63h-4.36v-.46h4.36v.46Zm-2.18 1.64h-2.18V9.4h2.18v.47Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        fontWeight="bold"
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={180.45} y={9.16}>
          {formatMessage(meetingNotesMessages['meeting-notes.field-4-name'])}
        </tspan>
      </text>
      <mask id="meetingNotes-s" fill="#fff">
        <path d="M168 16h56v36.66h-56V16Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M224 52.66v.31h.31v-.31H224ZM223.69 16v36.66h.62V16h-.62Zm.31 36.35h-56v.62h56v-.62Z"
        mask="url(#meetingNotes-s)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={172} y={24.66}>
          {formatMessage(meetingNotesMessages['meeting-notes.entry-1-cell-4']).substring(
            0,
            21
          )}
        </tspan>
        <tspan x={170.5} y={30.88}>
          {formatMessage(meetingNotesMessages['meeting-notes.entry-1-cell-4']).substring(
            21
          )}
        </tspan>
      </text>
      <mask id="meetingNotes-t" fill="#fff">
        <path d="M168 52.66h56v36.66h-56V52.66Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M224 89.32v.31h.31v-.31H224Zm-.31-36.66v36.66h.62V52.66h-.62Zm.31 36.35h-56v.62h56v-.62Z"
        mask="url(#meetingNotes-t)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={172} y={61.32}>
          {formatMessage(meetingNotesMessages['meeting-notes.entry-2-cell-4'])}
        </tspan>
      </text>
      <mask id="meetingNotes-u" fill="#fff">
        <path d="M168 89.32h56v36.66h-56V89.32Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M224 125.98v.31h.31v-.31H224Zm-.31-36.66v36.66h.62V89.32h-.62Zm.31 36.35h-56v.62h56v-.62Z"
        mask="url(#meetingNotes-u)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={172} y={97.98}>
          {formatMessage(meetingNotesMessages['meeting-notes.entry-3-cell-4'])}
        </tspan>
      </text>
      <mask id="meetingNotes-v" fill="#fff">
        <path d="M224 0h56v16h-56V0Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M280 0h.31v-.31H280V0Zm0 16v.31h.31V16H280ZM224 0v.31h56v-.62h-56V0Zm56 0h-.31v16h.62V0H280Zm0 16v-.31h-56v.62h56V16Z"
        mask="url(#meetingNotes-v)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M233.65 6.6h-4.36v-.47h4.36v.47Zm0 1.63h-4.36v-.46h4.36v.46Zm-2.18 1.64h-2.18V9.4h2.18v.47Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        fontWeight="bold"
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={236.45} y={9.16}>
          {formatMessage(meetingNotesMessages['meeting-notes.field-5-name'])}
        </tspan>
      </text>
      <mask id="meetingNotes-w" fill="#fff">
        <path d="M224 16h56v36.66h-56V16Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M280 52.66v.31h.31v-.31H280ZM279.69 16v36.66h.62V16h-.62Zm.31 36.35h-56v.62h56v-.62Z"
        mask="url(#meetingNotes-w)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={228} y={24.66}>
          {formatMessage(meetingNotesMessages['meeting-notes.entry-1-cell-5'])}
        </tspan>
      </text>
      <mask id="meetingNotes-x" fill="#fff">
        <path d="M224 52.66h56v36.66h-56V52.66Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M280 89.32v.31h.31v-.31H280Zm-.31-36.66v36.66h.62V52.66h-.62Zm.31 36.35h-56v.62h56v-.62Z"
        mask="url(#meetingNotes-x)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={228} y={61.32}>
          {formatMessage(meetingNotesMessages['meeting-notes.entry-2-cell-5'])}
        </tspan>
      </text>
      <mask id="meetingNotes-y" fill="#fff">
        <path d="M224 89.32h56v36.66h-56V89.32Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M280 125.98v.31h.31v-.31H280Zm-.31-36.66v36.66h.62V89.32h-.62Zm.31 36.35h-56v.62h56v-.62Z"
        mask="url(#meetingNotes-y)"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={228} y={97.98}>
          {formatMessage(meetingNotesMessages['meeting-notes.entry-3-cell-5']).substring(
            0,
            17
          )}
        </tspan>
        <tspan x={227} y={104.2}>
          {formatMessage(meetingNotesMessages['meeting-notes.entry-3-cell-5']).substring(
            17,
            35
          )}
        </tspan>
        <tspan x={227} y={110.42}>
          {formatMessage(meetingNotesMessages['meeting-notes.entry-3-cell-5']).substring(
            35
          )}
        </tspan>
      </text>
      <mask id="meetingNotes-z" fill="#fff">
        <path d="M280 0h53a3 3 0 0 1 3 3v13h-56V0Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M280-.31h53A3.31 3.31 0 0 1 336.31 3h-.62c0-1.49-1.2-2.69-2.69-2.69h-53v-.62Zm56.31 16.62H280v-.62h55.69l.62.62ZM280 16V0v16ZM333-.31A3.31 3.31 0 0 1 336.31 3v13.31l-.62-.62V3c0-1.49-1.2-2.69-2.69-2.69v-.62Z"
        mask="url(#meetingNotes-z)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M287.47 5.98a.78.78 0 1 0 0 1.55.78.78 0 0 0 0-1.55Zm-1.25.78a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm-.62 2.8c0-.65.52-1.17 1.17-1.17h1.4c.64 0 1.16.52 1.16 1.17v.62h-.46v-.62a.7.7 0 0 0-.7-.7h-1.4a.7.7 0 0 0-.7.7v.62h-.47v-.62Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        fontWeight="bold"
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={292.45} y={9.16}>
          {formatMessage(meetingNotesMessages['meeting-notes.field-6-name'])}
        </tspan>
      </text>
      <mask id="meetingNotes-A" fill="#fff">
        <path d="M280 16h56v36.66h-56V16Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M336 52.66v.31h.31v-.31H336ZM335.69 16v36.66h.62V16h-.62Zm.31 36.35h-56v.62h56v-.62Z"
        mask="url(#meetingNotes-A)"
      />
      <rect
        width={30.16}
        height={6.22}
        x={284}
        y={20}
        fill={templateStyles['userBackground']}
        rx={3.11}
      />
      <path
        fill={templateStyles['icon']}
        d="M287.34 25.5c-1.1 0-1.8-.7-1.8-1.78 0-1.05.72-1.77 1.76-1.77 1.01 0 1.71.64 1.71 1.56 0 .7-.31 1.14-.8 1.14-.24 0-.43-.14-.46-.35v-.01h-.04a.54.54 0 0 1-.53.34c-.44 0-.74-.37-.74-.9 0-.52.3-.88.74-.88.22 0 .41.11.5.3h.03v-.26h.32v1.24c0 .15.09.24.24.24.27 0 .44-.34.44-.86 0-.77-.58-1.3-1.43-1.3-.83 0-1.43.64-1.43 1.52 0 .91.58 1.5 1.5 1.5.29 0 .57-.04.7-.1v.26c-.18.07-.44.1-.7.1Zm-.11-1.17c.29 0 .47-.23.47-.6 0-.36-.18-.6-.47-.6-.28 0-.45.23-.45.6s.17.6.45.6Z"
      />
      <path
        fill={templateStyles['fontColor']}
        d="M291.56 24.68c-.29 0-.53-.06-.74-.19-.2-.13-.36-.31-.48-.55a1.97 1.97 0 0 1-.16-.84c0-.32.06-.6.17-.84.1-.24.27-.42.47-.55.21-.12.46-.19.74-.19.29 0 .54.07.74.2.21.12.37.3.48.54.11.24.17.52.17.84 0 .32-.06.6-.17.84a1.25 1.25 0 0 1-1.22.74Zm0-.34c.21 0 .39-.06.54-.16.15-.1.26-.24.34-.43.08-.18.12-.4.12-.65s-.04-.47-.12-.65a.97.97 0 0 0-.34-.43.93.93 0 0 0-.54-.15c-.2 0-.38.05-.53.15a.98.98 0 0 0-.34.43c-.09.18-.13.4-.13.65s.04.47.12.65a.93.93 0 0 0 .88.58Zm2.02.27v-3.15h.36v3.15h-.36Zm1.07 0v-2.25h.36v2.25h-.36Zm.18-2.69a.25.25 0 0 1-.25-.25c0-.07.03-.13.07-.18a.25.25 0 0 1 .18-.07c.07 0 .13.02.18.07.05.05.07.11.07.18 0 .07-.02.13-.07.18a.24.24 0 0 1-.18.07Zm1.5 2.7-.83-2.26h.39l.61 1.85h.04l.61-1.85h.39l-.84 2.25h-.37Zm1.7 0v-2.26h.36v2.25h-.36Zm.18-2.7a.25.25 0 0 1-.18-.07.25.25 0 0 1-.07-.18c0-.07.03-.13.07-.18.05-.05.11-.07.18-.07.07 0 .13.02.18.07.05.05.07.11.07.18 0 .07-.02.13-.07.18a.24.24 0 0 1-.18.07Zm1.49 2.73a.88.88 0 0 1-.39-.08.66.66 0 0 1-.27-.23.64.64 0 0 1-.1-.36.6.6 0 0 1 .1-.35c.06-.1.16-.17.28-.22.12-.06.27-.09.45-.1l.82-.05v.3l-.78.04a.69.69 0 0 0-.38.1.31.31 0 0 0-.11.27c0 .12.04.2.13.27.08.06.2.1.32.1.13 0 .24-.03.33-.08.1-.05.17-.12.23-.2a.52.52 0 0 0 .08-.29v-.7c0-.14-.04-.25-.13-.32-.08-.07-.2-.11-.37-.11a.68.68 0 0 0-.34.07.35.35 0 0 0-.17.2v.01h-.37v-.01a.6.6 0 0 1 .15-.31.79.79 0 0 1 .31-.2c.13-.06.27-.08.43-.08.18 0 .34.03.46.09.13.06.23.14.3.26.06.1.1.24.1.4v1.54h-.37v-.33h-.03a.76.76 0 0 1-.4.33.9.9 0 0 1-.28.04Zm3.82-.04v-1.3l-1.07-1.72h.43l.81 1.34h.04l.81-1.34h.43l-1.07 1.72v1.3h-.38Zm2.22.04a.89.89 0 0 1-.39-.08.66.66 0 0 1-.27-.23.64.64 0 0 1-.1-.36.6.6 0 0 1 .1-.35c.07-.1.16-.17.28-.22.12-.06.27-.09.45-.1l.83-.05v.3l-.79.04a.68.68 0 0 0-.38.1.31.31 0 0 0-.11.27c0 .12.04.2.13.27.08.06.2.1.32.1.13 0 .24-.03.33-.08.1-.05.18-.12.23-.2a.51.51 0 0 0 .08-.29v-.7c0-.14-.04-.25-.12-.32-.09-.07-.21-.11-.38-.11a.67.67 0 0 0-.33.07.35.35 0 0 0-.18.2v.01h-.37v-.01a.61.61 0 0 1 .15-.31.78.78 0 0 1 .31-.2c.13-.06.27-.08.43-.08.18 0 .34.03.47.09.13.06.22.14.29.26.06.1.1.24.1.4v1.54h-.37v-.33h-.03a.76.76 0 0 1-.4.33.9.9 0 0 1-.28.04Zm1.74-.04v-2.25h.37v.33h.03a.64.64 0 0 1 .25-.27c.1-.07.24-.1.4-.1.26 0 .46.07.6.21.13.15.2.35.2.62v1.46h-.37v-1.37c0-.2-.04-.36-.13-.45-.08-.1-.21-.15-.4-.15a.6.6 0 0 0-.3.08.53.53 0 0 0-.21.22c-.05.09-.07.2-.07.34v1.33h-.37Zm3.43.8c-.18 0-.34-.03-.47-.08a.77.77 0 0 1-.33-.22.63.63 0 0 1-.14-.32h.38c.02.09.08.16.17.21.1.06.23.08.4.08.2 0 .35-.04.47-.13.11-.1.17-.22.17-.39v-.46h-.04a.76.76 0 0 1-.41.35.92.92 0 0 1-.3.04.9.9 0 0 1-.5-.13.92.92 0 0 1-.32-.39 1.3 1.3 0 0 1-.12-.56c0-.21.04-.4.12-.56.07-.17.19-.3.33-.4a.9.9 0 0 1 .5-.13c.11 0 .2.01.3.05.09.03.17.08.24.14.06.06.12.13.17.22h.02v-.37h.37v2.22a.78.78 0 0 1-.47.72c-.15.07-.33.1-.54.1Zm-.01-1.24a.63.63 0 0 0 .59-.37.92.92 0 0 0 .08-.39.93.93 0 0 0-.08-.4.63.63 0 0 0-.24-.27.63.63 0 0 0-.35-.1.62.62 0 0 0-.36.1.64.64 0 0 0-.22.27 1 1 0 0 0-.08.4c0 .15.03.28.08.4.05.11.13.2.22.27.1.06.22.1.36.1Z"
      />
      <rect
        width={37.16}
        height={6.22}
        x={284}
        y={27.22}
        fill={templateStyles['userBackground']}
        rx={3.11}
      />
      <path
        fill={templateStyles['icon']}
        d="M287.34 32.72c-1.1 0-1.8-.69-1.8-1.77 0-1.06.72-1.78 1.76-1.78 1.01 0 1.71.64 1.71 1.56 0 .7-.31 1.14-.8 1.14-.24 0-.43-.14-.46-.35h-.04a.54.54 0 0 1-.53.33c-.44 0-.74-.36-.74-.9 0-.52.3-.88.74-.88.22 0 .41.11.5.3h.03v-.26h.32v1.25c0 .15.09.23.24.23.27 0 .44-.34.44-.86 0-.77-.58-1.3-1.43-1.3-.83 0-1.43.64-1.43 1.52 0 .91.58 1.5 1.5 1.5.29 0 .57-.04.7-.1v.27c-.18.06-.44.1-.7.1Zm-.11-1.17c.29 0 .47-.23.47-.6 0-.36-.18-.59-.47-.59-.28 0-.45.22-.45.6 0 .36.17.59.45.59Z"
      />
      <path
        fill={templateStyles['fontColor']}
        d="m291.19 31.83-1.13-3.07h.4l.9 2.58h.04l.9-2.58h.4l-1.13 3.07h-.38Zm2 0v-2.29h.38v2.3h-.37Zm.2-2.73a.25.25 0 0 1-.26-.26c0-.07.03-.13.07-.18a.25.25 0 0 1 .19-.07.24.24 0 0 1 .25.26.25.25 0 0 1-.25.26Zm1.81 2.77c-.21 0-.4-.05-.55-.14a.97.97 0 0 1-.37-.42 1.43 1.43 0 0 1-.13-.63c0-.24.04-.45.13-.62a.97.97 0 0 1 .92-.56c.19 0 .35.03.48.1a.84.84 0 0 1 .48.63v.01h-.36a.53.53 0 0 0-.2-.3.62.62 0 0 0-.4-.11.61.61 0 0 0-.59.4c-.05.12-.08.27-.08.45s.03.33.08.46a.7.7 0 0 0 .24.3c.1.07.22.1.35.1.16 0 .28-.03.38-.1.1-.06.17-.16.21-.29l.37-.01v.02a.96.96 0 0 1-.17.37.81.81 0 0 1-.31.25c-.13.06-.3.1-.48.1Zm2.36-.02c-.23 0-.4-.05-.51-.14-.1-.1-.16-.25-.16-.47v-1.4h-.36v-.3h.36v-.6h.38v.6h.5v.3h-.5v1.3c0 .14.03.24.08.3.05.05.14.08.26.08a1.4 1.4 0 0 0 .17 0v.3a2.8 2.8 0 0 1-.22.03Zm1.68.02a.96.96 0 0 1-.93-.55 1.45 1.45 0 0 1-.13-.63c0-.25.05-.46.13-.64.09-.18.21-.31.37-.4.16-.1.34-.15.56-.15.22 0 .4.05.56.14.16.1.28.23.37.41.08.18.13.39.13.63 0 .25-.05.46-.13.64a.95.95 0 0 1-.93.55Zm0-.32c.15 0 .27-.04.37-.1.1-.07.18-.17.23-.3.05-.13.08-.28.08-.46 0-.19-.03-.34-.08-.47a.62.62 0 0 0-.23-.29.64.64 0 0 0-.37-.1.64.64 0 0 0-.37.1.64.64 0 0 0-.23.3c-.05.12-.08.27-.08.45 0 .19.03.34.08.47.06.13.13.23.23.3.1.06.23.1.37.1Zm1.63.28v-2.29h.37v.34h.04a.54.54 0 0 1 .22-.28c.1-.07.23-.1.39-.1h.1l.08.02v.35a1.07 1.07 0 0 0-.22-.02.67.67 0 0 0-.32.07.54.54 0 0 0-.21.2.55.55 0 0 0-.08.3v1.41h-.37Zm1.67 0v-2.29h.37v2.3h-.37Zm.19-2.73a.25.25 0 0 1-.18-.08.25.25 0 0 1-.08-.18c0-.07.03-.13.08-.18a.25.25 0 0 1 .18-.07c.07 0 .13.02.18.07.05.05.07.11.07.18a.25.25 0 0 1-.25.26Zm1.5 2.77a.9.9 0 0 1-.38-.08.67.67 0 0 1-.28-.24.65.65 0 0 1-.1-.36.6.6 0 0 1 .1-.35c.06-.1.16-.17.28-.23.13-.05.28-.09.46-.1l.84-.05v.3l-.8.05a.7.7 0 0 0-.38.1.31.31 0 0 0-.12.27c0 .12.04.21.13.28.09.06.2.1.33.1s.24-.03.34-.08c.1-.05.17-.12.23-.2a.52.52 0 0 0 .08-.3v-.72c0-.14-.04-.25-.13-.32-.08-.07-.2-.11-.38-.11a.69.69 0 0 0-.34.07.36.36 0 0 0-.18.2v.01h-.37a.61.61 0 0 1 .15-.32.8.8 0 0 1 .32-.21c.12-.05.27-.08.43-.08.19 0 .35.03.48.1.13.05.23.14.3.26.06.1.1.24.1.4v1.57h-.38v-.33h-.03a.78.78 0 0 1-.4.33.91.91 0 0 1-.3.04Zm4.06.04c-.23 0-.42-.04-.59-.11a1 1 0 0 1-.4-.3.85.85 0 0 1-.16-.45v-.02h.38v.02c.01.1.05.2.12.27a.7.7 0 0 0 .27.17 1.18 1.18 0 0 0 .77 0c.1-.05.2-.11.26-.2.06-.07.09-.16.09-.26a.42.42 0 0 0-.14-.33.97.97 0 0 0-.46-.2l-.34-.07c-.3-.07-.53-.18-.67-.32a.76.76 0 0 1-.2-.55.8.8 0 0 1 .13-.45c.1-.13.22-.23.38-.3.16-.08.35-.12.56-.12.2 0 .39.04.54.11.16.07.29.17.38.3.1.12.14.26.15.41v.03h-.38v-.03a.48.48 0 0 0-.11-.24.61.61 0 0 0-.24-.17.89.89 0 0 0-.35-.05.95.95 0 0 0-.34.05c-.1.04-.19.1-.25.18a.42.42 0 0 0-.09.27c0 .12.05.23.14.31.09.08.24.15.45.2l.34.07c.21.05.39.1.52.18.13.08.22.17.28.28a.86.86 0 0 1-.05.88.91.91 0 0 1-.4.32c-.16.08-.36.12-.6.12Zm2.54-.06c-.24 0-.4-.05-.51-.14-.11-.1-.16-.25-.16-.47v-1.4h-.36v-.3h.36v-.6h.38v.6h.5v.3h-.5v1.3c0 .14.03.24.08.3.05.05.13.08.25.08a1.36 1.36 0 0 0 .17 0v.3a2.76 2.76 0 0 1-.21.03Zm.96.79a.88.88 0 0 1-.16-.02v-.3h.07l.08.01c.1 0 .2-.03.26-.08a.56.56 0 0 0 .16-.28l.04-.13-.85-2.3h.4l.7 2.12-.14-.23h.17l-.14.23.7-2.12h.4l-.9 2.43c-.07.18-.13.3-.2.4a.57.57 0 0 1-.25.2c-.09.05-.2.07-.34.07Zm2.2-.8v-3.21h.36v3.2h-.37Zm2 .03c-.21 0-.4-.04-.56-.14a.96.96 0 0 1-.36-.4 1.45 1.45 0 0 1-.12-.63c0-.24.04-.45.12-.63a1 1 0 0 1 .36-.42c.16-.1.34-.15.54-.15.21 0 .4.05.54.14.15.1.26.24.35.4.08.18.12.38.12.6v.15h-1.84v-.3h1.65l-.19.28v-.15c0-.18-.02-.33-.08-.44a.57.57 0 0 0-.55-.35.62.62 0 0 0-.33.1.61.61 0 0 0-.23.26.99.99 0 0 0-.08.43v.15c0 .16.02.3.08.42a.61.61 0 0 0 .6.35c.1 0 .19-.01.27-.04a.6.6 0 0 0 .19-.1.4.4 0 0 0 .1-.14v-.02h.38v.02a.7.7 0 0 1-.11.22.85.85 0 0 1-.2.2.98.98 0 0 1-.28.14c-.1.04-.23.05-.36.05Zm2.35 0c-.17 0-.32-.02-.45-.07a.8.8 0 0 1-.32-.22.6.6 0 0 1-.14-.33h.38c.03.1.1.17.19.23.08.06.2.09.35.09.1 0 .2-.02.27-.05a.47.47 0 0 0 .19-.12.28.28 0 0 0 .07-.19.25.25 0 0 0-.1-.2.73.73 0 0 0-.3-.14l-.36-.08a1.3 1.3 0 0 1-.35-.13.55.55 0 0 1-.2-.2.59.59 0 0 1-.07-.29c0-.13.04-.24.11-.34.07-.1.18-.18.3-.24.13-.06.28-.09.44-.09.16 0 .3.03.43.08.12.05.22.12.3.21.07.1.12.2.14.32h-.37a.38.38 0 0 0-.16-.22.6.6 0 0 0-.34-.08c-.1 0-.17.01-.24.04a.41.41 0 0 0-.17.12.28.28 0 0 0-.06.18c0 .06.01.1.04.14.02.04.07.08.12.1.06.04.13.06.22.08l.36.09c.21.05.37.13.48.22.1.1.16.23.16.4 0 .14-.05.26-.13.36a.8.8 0 0 1-.32.25c-.14.05-.3.08-.47.08Z"
      />
      <mask id="meetingNotes-B" fill="#fff">
        <path d="M280 52.66h56v36.66h-56V52.66Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M336 89.32v.31h.31v-.31H336Zm-.31-36.66v36.66h.62V52.66h-.62Zm.31 36.35h-56v.62h56v-.62Z"
        mask="url(#meetingNotes-B)"
      />
      <rect
        width={32.16}
        height={6.22}
        x={284}
        y={56.66}
        fill={templateStyles['userBackground']}
        rx={3.11}
      />
      <path
        fill={templateStyles['icon']}
        d="M287.34 62.16c-1.1 0-1.8-.7-1.8-1.78 0-1.05.72-1.77 1.76-1.77 1.01 0 1.71.64 1.71 1.56 0 .7-.31 1.14-.8 1.14-.24 0-.43-.14-.46-.35v-.01h-.04a.54.54 0 0 1-.53.34c-.44 0-.74-.37-.74-.9 0-.52.3-.88.74-.88.22 0 .41.11.5.3h.03v-.26h.32v1.24c0 .15.09.24.24.24.27 0 .44-.34.44-.86 0-.77-.58-1.3-1.43-1.3-.83 0-1.43.64-1.43 1.52 0 .91.58 1.5 1.5 1.5.29 0 .57-.04.7-.1v.26c-.18.07-.44.1-.7.1Zm-.11-1.17c.29 0 .47-.23.47-.6 0-.36-.18-.6-.47-.6-.28 0-.45.23-.45.6s.17.6.45.6Z"
      />
      <path
        fill={templateStyles['fontColor']}
        d="M290.3 61.27v-3.02h1.83v.34h-1.46v1.04h1.34v.33h-1.34v1.31h-.37Zm2.41 0v-2.25h.36v2.25h-.36Zm.18-2.69a.25.25 0 0 1-.25-.25c0-.07.03-.13.08-.18a.25.25 0 0 1 .17-.07c.07 0 .13.02.18.07.05.05.07.11.07.18 0 .07-.02.13-.07.18a.24.24 0 0 1-.18.07Zm1.7 2.73a.87.87 0 0 1-.83-.55 1.5 1.5 0 0 1-.11-.61c0-.24.04-.45.11-.62a.87.87 0 0 1 .83-.55.84.84 0 0 1 .54.18c.07.06.13.13.17.21h.03v-1.25h.36v3.15h-.36v-.36h-.03a.77.77 0 0 1-.7.4Zm.09-.32a.6.6 0 0 0 .35-.1c.1-.07.18-.17.23-.3.05-.12.08-.27.08-.44 0-.18-.03-.33-.08-.46a.65.65 0 0 0-.23-.29.6.6 0 0 0-.35-.1.6.6 0 0 0-.36.1.64.64 0 0 0-.22.29c-.06.13-.08.28-.08.45 0 .18.03.33.08.46.05.12.13.22.22.29.1.07.22.1.36.1Zm2.63.32c-.21 0-.4-.05-.55-.14a.94.94 0 0 1-.36-.4 1.43 1.43 0 0 1-.12-.62c0-.23.04-.44.12-.61a.95.95 0 0 1 .89-.56c.2 0 .38.04.53.14.14.1.26.23.33.4.09.16.12.36.12.59v.14h-1.8v-.3h1.62l-.18.27v-.14c0-.18-.03-.32-.08-.44a.56.56 0 0 0-.22-.25.6.6 0 0 0-.32-.09.6.6 0 0 0-.33.1.6.6 0 0 0-.22.25.98.98 0 0 0-.09.43v.14c0 .16.03.3.08.42a.6.6 0 0 0 .6.35c.1 0 .18-.02.26-.05a.57.57 0 0 0 .18-.1.4.4 0 0 0 .1-.13l.01-.02h.37v.01a.67.67 0 0 1-.11.23.82.82 0 0 1-.2.2.98.98 0 0 1-.27.13c-.1.03-.23.05-.36.05Zm1.55-.04v-3.15h.36v3.15h-.36Zm1.07 0v-2.25h.37v2.25h-.37Zm.19-2.69a.25.25 0 0 1-.26-.25c0-.07.03-.13.08-.18a.25.25 0 0 1 .18-.07c.06 0 .12.02.17.07a.25.25 0 0 1 0 .36.24.24 0 0 1-.18.07Zm1.63 2.73a1.2 1.2 0 0 1-.44-.07.78.78 0 0 1-.3-.22.6.6 0 0 1-.14-.32h.37c.03.09.09.16.18.22s.2.09.35.09c.1 0 .19-.02.27-.05a.46.46 0 0 0 .18-.12.28.28 0 0 0 .07-.18.25.25 0 0 0-.1-.2.71.71 0 0 0-.3-.13l-.35-.09a1.26 1.26 0 0 1-.34-.13.53.53 0 0 1-.2-.2.58.58 0 0 1-.07-.27c0-.13.04-.24.11-.34.07-.1.17-.18.3-.24.13-.06.27-.08.43-.08.16 0 .3.02.42.07s.22.12.3.21c.07.1.12.2.13.32h-.36a.37.37 0 0 0-.16-.22.6.6 0 0 0-.33-.08.62.62 0 0 0-.24.04.4.4 0 0 0-.17.12.27.27 0 0 0-.06.18c0 .05.02.1.04.13.03.04.07.08.13.1.05.04.12.06.21.08l.35.09c.21.05.37.12.47.22.1.1.16.23.16.39 0 .13-.04.25-.12.36a.8.8 0 0 1-.32.24c-.14.05-.3.08-.47.08Zm2.73-.04v-3.02h1.87v.34h-1.5v.97h1.42v.33h-1.42v1.04h1.5v.34h-1.88Zm2.18.78h-.06v-.33h.05c.12 0 .2-.02.26-.07.05-.05.08-.14.08-.26v-2.37h.36v2.36c0 .23-.06.4-.17.5-.11.11-.28.17-.52.17Zm.5-3.47a.25.25 0 0 1-.17-.07.25.25 0 0 1-.07-.18c0-.07.02-.13.07-.18a.25.25 0 0 1 .18-.07c.07 0 .13.02.18.07.05.05.07.11.07.18 0 .07-.02.13-.07.18a.24.24 0 0 1-.18.07Zm.89 2.7v-2.26h.36v2.25h-.36Zm.18-2.7a.25.25 0 0 1-.18-.07.25.25 0 0 1-.07-.18.25.25 0 0 1 .25-.25.25.25 0 0 1 .25.25.25.25 0 0 1-.25.25Zm.87 2.7v-2.26h.36v.34h.04a.6.6 0 0 1 .23-.28c.1-.07.23-.1.37-.1.1 0 .2.01.28.05.08.03.15.08.2.14.07.06.11.12.15.2h.03a.72.72 0 0 1 .4-.35c.1-.03.19-.04.3-.04a.8.8 0 0 1 .38.08c.1.06.19.14.25.25.05.11.08.25.08.4v1.56h-.37V59.8c0-.12-.01-.2-.05-.28a.34.34 0 0 0-.15-.17.55.55 0 0 0-.27-.05.5.5 0 0 0-.46.26.53.53 0 0 0-.06.26v1.45h-.36v-1.53a.45.45 0 0 0-.06-.23.38.38 0 0 0-.16-.16.52.52 0 0 0-.25-.05c-.1 0-.19.02-.27.08a.55.55 0 0 0-.18.2.62.62 0 0 0-.07.3v1.4h-.36Zm4.34.03a.88.88 0 0 1-.38-.08.66.66 0 0 1-.27-.23.63.63 0 0 1-.1-.36.6.6 0 0 1 .1-.35c.06-.1.15-.17.28-.22.12-.06.27-.09.44-.1l.83-.05v.3l-.78.04a.69.69 0 0 0-.38.11.31.31 0 0 0-.12.26c0 .12.05.2.13.27.09.06.2.1.33.1.12 0 .23-.03.33-.08s.17-.12.23-.2a.51.51 0 0 0 .08-.29v-.7c0-.14-.04-.25-.13-.32-.08-.07-.2-.11-.38-.11a.68.68 0 0 0-.33.07.35.35 0 0 0-.17.2v.01h-.37v-.01a.6.6 0 0 1 .15-.31.79.79 0 0 1 .3-.2c.13-.06.28-.08.44-.08.18 0 .34.03.46.09.13.06.23.14.3.26.06.1.1.24.1.4v1.54h-.37v-.33h-.03a.78.78 0 0 1-.4.33.9.9 0 0 1-.29.04Z"
      />
      <rect
        width={39.16}
        height={6.22}
        x={284}
        y={63.88}
        fill={templateStyles['userBackground']}
        rx={3.11}
      />
      <path
        fill={templateStyles['icon']}
        d="M287.34 69.38c-1.1 0-1.8-.69-1.8-1.77 0-1.06.72-1.78 1.76-1.78 1.01 0 1.71.64 1.71 1.56 0 .7-.31 1.14-.8 1.14-.24 0-.43-.14-.46-.35h-.04a.54.54 0 0 1-.53.33c-.44 0-.74-.36-.74-.9 0-.52.3-.88.74-.88.22 0 .41.11.5.3h.03v-.26h.32v1.25c0 .15.09.23.24.23.27 0 .44-.34.44-.86 0-.77-.58-1.3-1.43-1.3-.83 0-1.43.64-1.43 1.52 0 .91.58 1.5 1.5 1.5.29 0 .57-.04.7-.1v.27c-.18.06-.44.1-.7.1Zm-.11-1.17c.29 0 .47-.23.47-.6 0-.36-.18-.59-.47-.59-.28 0-.45.22-.45.6 0 .36.17.59.45.59Z"
      />
      <path
        fill={templateStyles['fontColor']}
        d="m290.06 68.5 1.13-3.08h.3v.5h-.13l-.9 2.57h-.4Zm.51-.89.12-.32h1.39l.12.32h-1.63Zm1.73.88-.9-2.57v-.5h.17l1.13 3.07h-.4Zm1.55.04a.89.89 0 0 1-.43-.1.64.64 0 0 1-.27-.28 1.11 1.11 0 0 1-.09-.46V66.2h.37v1.4c0 .2.04.35.12.46.08.1.21.15.4.15.1 0 .19-.02.26-.05a.52.52 0 0 0 .2-.13c.05-.05.1-.12.12-.2a.86.86 0 0 0 .04-.27V66.2h.37v2.3h-.37v-.35h-.04a.65.65 0 0 1-.15.2.66.66 0 0 1-.23.14.93.93 0 0 1-.3.04Zm2.56 0c-.17 0-.32-.02-.45-.07a.78.78 0 0 1-.31-.22.6.6 0 0 1-.14-.33h.38c.03.1.1.17.18.23.1.06.21.09.36.09.1 0 .2-.02.27-.05a.48.48 0 0 0 .19-.12.28.28 0 0 0 .06-.19.25.25 0 0 0-.09-.2.72.72 0 0 0-.3-.14l-.36-.08a1.3 1.3 0 0 1-.35-.13.55.55 0 0 1-.2-.2.59.59 0 0 1-.07-.29c0-.13.03-.24.1-.34.08-.1.19-.18.31-.24.13-.06.28-.09.44-.09.16 0 .3.03.43.08.12.05.22.12.3.21.07.1.12.2.13.32h-.36a.38.38 0 0 0-.16-.22.61.61 0 0 0-.34-.08.62.62 0 0 0-.25.04.4.4 0 0 0-.16.12.28.28 0 0 0-.06.18c0 .06 0 .1.04.14.02.04.06.08.12.1.06.04.13.06.22.08l.35.09c.22.05.38.13.48.22.11.1.16.23.16.4 0 .14-.04.26-.12.36a.8.8 0 0 1-.33.25c-.13.05-.3.08-.46.08Zm2.3-.02c-.24 0-.41-.05-.52-.14-.1-.1-.16-.25-.16-.47v-1.4h-.36v-.3h.36v-.6h.38v.6h.5v.3h-.5v1.3c0 .14.03.24.08.3.05.05.14.08.26.08a1.4 1.4 0 0 0 .17 0v.3a2.62 2.62 0 0 1-.22.03Zm.77-.02V66.2h.37v2.3h-.37Zm.18-2.73a.25.25 0 0 1-.18-.08.25.25 0 0 1-.07-.18c0-.07.02-.13.07-.18a.25.25 0 0 1 .18-.07c.07 0 .13.02.19.07.04.05.07.11.07.18 0 .07-.03.13-.07.18a.25.25 0 0 1-.19.08Zm.88 2.73V66.2h.38v.35h.03a.65.65 0 0 1 .25-.29c.1-.07.25-.1.42-.1.25 0 .45.07.59.22.14.15.2.36.2.63v1.48h-.36v-1.4c0-.2-.05-.35-.13-.45-.09-.1-.23-.15-.4-.15a.61.61 0 0 0-.32.08.54.54 0 0 0-.21.22.77.77 0 0 0-.07.35v1.35h-.38Zm3.82 0v-3.07h.38v2.73h1.48v.34h-1.86Zm3.06.04a.9.9 0 0 1-.4-.08.67.67 0 0 1-.27-.24.64.64 0 0 1-.1-.36.6.6 0 0 1 .1-.35c.07-.1.16-.17.29-.23.12-.05.27-.09.45-.1l.84-.05v.3l-.8.05a.7.7 0 0 0-.38.1.32.32 0 0 0-.12.27c0 .12.05.21.13.28.1.06.2.1.33.1s.24-.03.34-.08a.6.6 0 0 0 .23-.2.53.53 0 0 0 .09-.3v-.72c0-.14-.05-.25-.13-.32-.09-.07-.22-.11-.39-.11a.68.68 0 0 0-.34.07.36.36 0 0 0-.17.2v.01h-.38a.62.62 0 0 1 .15-.32.8.8 0 0 1 .32-.21c.13-.05.27-.08.43-.08.2 0 .35.03.48.1.13.05.23.14.3.26.06.1.1.25.1.4v1.57h-.37v-.33h-.04a.76.76 0 0 1-.7.37Zm1.77-.04V66.2h.37v.35h.04a.61.61 0 0 1 .23-.29.7.7 0 0 1 .38-.1c.1 0 .2.02.28.05.09.04.16.08.22.14.06.06.1.13.14.21h.03c.04-.08.1-.15.17-.2.07-.07.15-.12.24-.15.1-.03.19-.05.3-.05.15 0 .28.03.39.09.1.06.2.14.25.25.06.11.08.25.08.4v1.6h-.37V67c0-.12-.01-.21-.05-.29a.35.35 0 0 0-.16-.16.56.56 0 0 0-.26-.06c-.11 0-.2.02-.28.07a.5.5 0 0 0-.19.2.54.54 0 0 0-.06.26v1.47h-.37v-1.55c0-.1-.02-.17-.06-.24a.38.38 0 0 0-.17-.16.54.54 0 0 0-.25-.05c-.1 0-.19.02-.27.08a.56.56 0 0 0-.19.2.64.64 0 0 0-.07.3v1.42h-.37Zm4.93.04c-.1 0-.2-.01-.3-.05a.79.79 0 0 1-.42-.36h-.03v.37H313v-3.2h.37v1.27h.04a.7.7 0 0 1 .41-.35c.1-.03.2-.05.3-.05.2 0 .37.05.5.15.15.1.26.23.34.41.08.18.12.39.12.62 0 .25-.04.46-.12.63a.95.95 0 0 1-.33.42.87.87 0 0 1-.5.14Zm-.08-.32c.14 0 .26-.04.36-.1.1-.08.17-.17.22-.3.06-.13.08-.28.08-.46s-.02-.34-.08-.46a.64.64 0 0 0-.22-.3.61.61 0 0 0-.36-.1.62.62 0 0 0-.36.1.66.66 0 0 0-.23.3c-.06.13-.08.28-.08.45 0 .18.02.34.08.47.05.12.13.22.23.3.1.06.22.1.36.1Zm2.55.32c-.21 0-.4-.04-.56-.14a.96.96 0 0 1-.36-.4 1.45 1.45 0 0 1-.13-.63c0-.24.04-.45.13-.63a1 1 0 0 1 .36-.42c.15-.1.33-.15.54-.15.2 0 .39.05.54.14.15.1.26.24.34.4.08.18.12.38.12.6v.15h-1.84v-.3h1.65l-.18.28v-.15c0-.18-.03-.33-.08-.44a.56.56 0 0 0-.23-.26.61.61 0 0 0-.32-.09.61.61 0 0 0-.33.1.61.61 0 0 0-.23.26.99.99 0 0 0-.09.43v.15c0 .16.03.3.08.42a.62.62 0 0 0 .6.35c.1 0 .2-.01.27-.04a.6.6 0 0 0 .2-.1.4.4 0 0 0 .1-.14v-.02h.37v.02a.71.71 0 0 1-.1.22.84.84 0 0 1-.2.2 1 1 0 0 1-.28.14c-.11.04-.23.05-.37.05Zm1.56-.04V66.2h.37v.34h.03a.54.54 0 0 1 .22-.28c.1-.07.24-.1.4-.1h.1l.08.02v.35a1.06 1.06 0 0 0-.23-.02.67.67 0 0 0-.31.07.54.54 0 0 0-.22.2.55.55 0 0 0-.07.3v1.41h-.37Zm2.51.02c-.23 0-.4-.05-.51-.14-.1-.1-.16-.25-.16-.47v-1.4h-.36v-.3h.36v-.6h.38v.6h.5v.3h-.5v1.3c0 .14.03.24.08.3.05.05.14.08.26.08a1.36 1.36 0 0 0 .17 0v.3a2.35 2.35 0 0 1-.22.03Z"
      />
      <mask id="meetingNotes-C" fill="#fff">
        <path d="M280 89.32h56v36.66h-56V89.32Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M336 125.98v.31h.31v-.31H336Zm-.31-36.66v36.66h.62V89.32h-.62Zm.31 36.35h-56v.62h56v-.62Z"
        mask="url(#meetingNotes-C)"
      />
      <rect
        width={30.16}
        height={6.22}
        x={284}
        y={93.32}
        fill={templateStyles['userBackground']}
        rx={3.11}
      />
      <path
        fill={templateStyles['icon']}
        d="M287.34 98.82c-1.1 0-1.8-.7-1.8-1.78 0-1.05.72-1.77 1.76-1.77 1.01 0 1.71.64 1.71 1.56 0 .7-.31 1.14-.8 1.14-.24 0-.43-.14-.46-.35v-.01h-.04a.54.54 0 0 1-.53.34c-.44 0-.74-.37-.74-.9 0-.52.3-.88.74-.88.22 0 .41.11.5.3h.03v-.26h.32v1.24c0 .15.09.24.24.24.27 0 .44-.34.44-.86 0-.77-.58-1.3-1.43-1.3-.83 0-1.43.64-1.43 1.52 0 .91.58 1.5 1.5 1.5.29 0 .57-.04.7-.1v.26c-.18.07-.44.1-.7.1Zm-.11-1.17c.29 0 .47-.23.47-.6 0-.36-.18-.6-.47-.6-.28 0-.45.23-.45.6s.17.6.45.6Z"
      />
      <path
        fill={templateStyles['fontColor']}
        d="M290.3 97.93v-3.07h1.17c.2 0 .37.04.52.12.15.07.26.18.34.31.08.14.12.3.12.48 0 .22-.05.4-.16.56a.85.85 0 0 1-.45.33l.7 1.27h-.44l-.66-1.21h-.76v1.21h-.38Zm.38-1.55h.76c.2 0 .35-.05.45-.15.11-.1.17-.25.17-.44a.56.56 0 0 0-.17-.43.66.66 0 0 0-.47-.16h-.74v1.18Zm3.3 1.6c-.22 0-.4-.06-.56-.15a.97.97 0 0 1-.37-.41 1.45 1.45 0 0 1-.13-.63c0-.25.04-.46.13-.64a.96.96 0 0 1 .93-.55c.22 0 .4.05.56.14.16.1.28.23.37.4.08.19.13.4.13.64 0 .25-.05.46-.13.64a.95.95 0 0 1-.93.55Zm0-.34c.14 0 .27-.03.37-.1.1-.07.17-.16.23-.3.05-.12.08-.27.08-.45 0-.19-.03-.34-.08-.47a.62.62 0 0 0-.23-.3.64.64 0 0 0-.37-.1.64.64 0 0 0-.37.1.63.63 0 0 0-.23.3 1.2 1.2 0 0 0-.08.46c0 .19.03.34.08.47.05.13.13.22.23.3.1.06.22.1.37.1Zm2.77.33c-.1 0-.2-.01-.3-.05a.78.78 0 0 1-.41-.35H296v.36h-.37v-3.2h.37V96h.04a.7.7 0 0 1 .17-.21c.07-.06.15-.1.24-.14.1-.04.2-.05.3-.05.2 0 .36.05.5.14.15.1.26.24.34.42.08.17.12.38.12.62 0 .25-.04.45-.12.63a.96.96 0 0 1-.33.41.88.88 0 0 1-.5.15Zm-.08-.33c.14 0 .26-.03.35-.1.1-.07.18-.17.23-.3.06-.12.08-.28.08-.45 0-.19-.02-.34-.08-.47a.64.64 0 0 0-.23-.29.61.61 0 0 0-.35-.1.62.62 0 0 0-.36.1.67.67 0 0 0-.24.3c-.05.12-.08.28-.08.45 0 .18.03.34.08.46.06.13.14.23.24.3.1.07.22.1.36.1Zm1.63.3v-2.3h.37v2.3h-.38Zm.18-2.74a.25.25 0 0 1-.18-.08.25.25 0 0 1-.07-.18c0-.07.02-.13.07-.18a.25.25 0 0 1 .18-.07.25.25 0 0 1 .25.26.25.25 0 0 1-.25.25Zm2.15 2.73v-3.07h.39v2.73h1.48v.34h-1.87Zm3.27.04c-.22 0-.4-.05-.56-.14a.97.97 0 0 1-.37-.41 1.45 1.45 0 0 1-.13-.63c0-.25.04-.46.13-.64a.96.96 0 0 1 .93-.55c.22 0 .4.05.56.14.16.1.28.23.37.4.08.19.13.4.13.64 0 .25-.05.46-.13.64a.95.95 0 0 1-.93.55Zm0-.33c.14 0 .27-.03.37-.1.1-.07.17-.16.23-.3.05-.12.08-.27.08-.45 0-.19-.03-.34-.08-.47a.62.62 0 0 0-.23-.3.64.64 0 0 0-.37-.1.64.64 0 0 0-.37.1.63.63 0 0 0-.23.3 1.2 1.2 0 0 0-.08.46c0 .19.03.34.08.47.05.13.13.22.23.3.1.06.22.1.37.1Zm1.63 1.06v-3.06h.37V96h.03a.77.77 0 0 1 .42-.35c.1-.04.2-.05.3-.05.2 0 .36.05.5.15.15.1.26.23.34.4.08.19.12.4.12.63 0 .25-.04.45-.12.63a.96.96 0 0 1-.34.41.88.88 0 0 1-.5.15.85.85 0 0 1-.55-.19.68.68 0 0 1-.17-.21h-.03v1.13h-.37Zm1.03-1.06c.14 0 .26-.03.36-.1.1-.07.18-.17.23-.3.05-.12.08-.28.08-.45 0-.19-.03-.34-.08-.47a.64.64 0 0 0-.23-.29.61.61 0 0 0-.36-.1.62.62 0 0 0-.36.1.66.66 0 0 0-.23.3c-.05.12-.08.28-.08.45 0 .18.03.34.08.46.06.13.13.23.23.3.1.07.23.1.36.1Zm2.56.33c-.21 0-.4-.05-.56-.14a.96.96 0 0 1-.36-.41 1.45 1.45 0 0 1-.13-.63c0-.24.05-.44.13-.62a1 1 0 0 1 .36-.42c.15-.1.33-.15.54-.15.2 0 .39.05.54.14.15.1.26.23.34.4.08.18.12.38.12.6v.15h-1.84v-.3h1.65l-.18.28v-.15c0-.18-.03-.33-.08-.45a.57.57 0 0 0-.55-.34.61.61 0 0 0-.33.09.62.62 0 0 0-.23.26.99.99 0 0 0-.09.44v.15c0 .16.03.3.09.41a.61.61 0 0 0 .6.36c.1 0 .19-.01.26-.04a.6.6 0 0 0 .2-.1.4.4 0 0 0 .1-.14v-.02h.38l-.01.01a.69.69 0 0 1-.1.23.84.84 0 0 1-.2.2 1 1 0 0 1-.28.14c-.11.03-.23.05-.37.05Zm1.5-.04v-.27l1.33-1.68v-.04h-1.32v-.3h1.75v.27l-1.31 1.68v.03h1.32v.31h-1.77Z"
      />
      <rect
        width={31.16}
        height={6.22}
        x={284}
        y={100.54}
        fill={templateStyles['userBackground']}
        rx={3.11}
      />
      <path
        fill={templateStyles['icon']}
        d="M287.34 106.04c-1.1 0-1.8-.69-1.8-1.77 0-1.06.72-1.78 1.76-1.78 1.01 0 1.71.64 1.71 1.56 0 .7-.31 1.14-.8 1.14-.24 0-.43-.14-.46-.34v-.02h-.04a.54.54 0 0 1-.53.34c-.44 0-.74-.36-.74-.9 0-.52.3-.88.74-.88.22 0 .41.11.5.3h.03v-.26h.32v1.25c0 .14.09.23.24.23.27 0 .44-.34.44-.86 0-.77-.58-1.3-1.43-1.3-.83 0-1.43.64-1.43 1.53 0 .9.58 1.49 1.5 1.49.29 0 .57-.04.7-.1v.27c-.18.06-.44.1-.7.1Zm-.11-1.17c.29 0 .47-.23.47-.6 0-.36-.18-.59-.47-.59-.28 0-.45.22-.45.6 0 .36.17.59.45.59Z"
      />
      <path
        fill={templateStyles['fontColor']}
        d="m290.06 105.15 1.13-3.07h.3v.5h-.13l-.9 2.57h-.4Zm.51-.88.12-.32h1.39l.12.33h-1.63Zm1.73.88-.9-2.57v-.5h.17l1.13 3.07h-.4Zm.9 0v-2.29h.36v.34h.04a.65.65 0 0 1 .25-.28c.1-.07.24-.1.41-.1.26 0 .46.07.6.22.13.15.2.36.2.63v1.48h-.37v-1.4c0-.2-.04-.35-.13-.45-.08-.1-.22-.15-.4-.15a.62.62 0 0 0-.32.08.54.54 0 0 0-.2.22.77.77 0 0 0-.08.35v1.35h-.37Zm2.53 0v-2.29h.37v.34h.04a.65.65 0 0 1 .25-.28c.1-.07.25-.1.42-.1.25 0 .45.07.59.22.14.15.2.36.2.63v1.48h-.36v-1.4c0-.2-.05-.35-.13-.45-.1-.1-.23-.15-.4-.15a.62.62 0 0 0-.32.08.55.55 0 0 0-.21.22.77.77 0 0 0-.08.35v1.35h-.37Zm2.56 0v-2.29h.37v2.3h-.37Zm.18-2.73a.25.25 0 0 1-.18-.08.25.25 0 0 1-.07-.18c0-.07.02-.13.07-.18a.25.25 0 0 1 .18-.07.25.25 0 0 1 .26.25c0 .07-.03.13-.08.18a.25.25 0 0 1-.18.08Zm1.82 2.77c-.22 0-.4-.05-.56-.14a.97.97 0 0 1-.37-.4 1.47 1.47 0 0 1-.12-.64c0-.23.04-.44.12-.62a1 1 0 0 1 .36-.42c.16-.1.34-.15.55-.15a.93.93 0 0 1 .88.55c.08.17.12.37.12.6v.14h-1.84v-.3h1.65l-.18.28v-.15c0-.18-.03-.33-.08-.44a.57.57 0 0 0-.56-.35.62.62 0 0 0-.33.1.61.61 0 0 0-.23.26 1 1 0 0 0-.08.43v.15c0 .16.02.3.08.42.06.11.13.2.24.26a.76.76 0 0 0 .63.05.57.57 0 0 0 .19-.1.4.4 0 0 0 .1-.14l.01-.02h.37v.02a.7.7 0 0 1-.11.22.83.83 0 0 1-.2.2c-.07.06-.17.1-.28.14-.1.04-.23.05-.36.05Zm4.06.04a1.3 1.3 0 0 1-.72-.2c-.2-.13-.36-.32-.47-.56a2.03 2.03 0 0 1-.17-.85c0-.33.06-.62.17-.86.1-.24.26-.42.47-.55.2-.13.44-.2.72-.2.21 0 .4.05.58.13a1.16 1.16 0 0 1 .66.87h-.39a.84.84 0 0 0-.47-.57.9.9 0 0 0-.38-.08c-.2 0-.37.06-.51.16a.98.98 0 0 0-.33.43c-.08.19-.12.41-.12.67 0 .26.04.48.12.66a.87.87 0 0 0 .85.59c.13 0 .26-.02.38-.07a.8.8 0 0 0 .3-.2.71.71 0 0 0 .16-.3h.39a1.05 1.05 0 0 1-.65.81c-.18.08-.37.12-.59.12Zm1.86-.08v-3.2h.37v3.2h-.37Zm1.7.04a.9.9 0 0 1-.39-.08.68.68 0 0 1-.27-.23.65.65 0 0 1-.1-.37.6.6 0 0 1 .1-.35c.06-.1.16-.17.28-.23.13-.06.28-.09.46-.1l.84-.05v.3l-.8.05a.7.7 0 0 0-.38.1.32.32 0 0 0-.12.27c0 .12.04.21.13.28.09.06.2.1.33.1s.24-.03.34-.08a.6.6 0 0 0 .23-.2.52.52 0 0 0 .08-.3v-.72c0-.14-.04-.25-.13-.32-.08-.08-.21-.11-.38-.11a.68.68 0 0 0-.34.07.36.36 0 0 0-.18.2v.02h-.37v-.02a.62.62 0 0 1 .15-.31.8.8 0 0 1 .32-.21c.12-.05.27-.08.43-.08.19 0 .35.03.48.1.13.05.23.14.3.25.06.12.1.25.1.41v1.57h-.38v-.34h-.03a.77.77 0 0 1-.7.38Zm1.78-.04v-2.29h.37v.34h.03a.54.54 0 0 1 .23-.28c.1-.07.23-.1.39-.1h.1l.08.02v.35a.88.88 0 0 0-.11-.01h-.12a.68.68 0 0 0-.3.06.54.54 0 0 0-.22.2.56.56 0 0 0-.08.3v1.41h-.37Zm2.53.04c-.22 0-.4-.05-.56-.14a.97.97 0 0 1-.37-.4 1.47 1.47 0 0 1-.12-.64c0-.23.04-.44.13-.62a1 1 0 0 1 .35-.42c.16-.1.34-.15.55-.15a.93.93 0 0 1 .88.55c.08.17.12.37.12.6v.14h-1.84v-.3h1.65l-.18.28v-.15c0-.18-.03-.33-.08-.44a.57.57 0 0 0-.56-.35.62.62 0 0 0-.33.1.61.61 0 0 0-.23.26 1 1 0 0 0-.08.43v.15c0 .16.03.3.08.42.06.11.13.2.24.26a.76.76 0 0 0 .63.05.57.57 0 0 0 .19-.1.4.4 0 0 0 .1-.14l.01-.02h.37v.02a.7.7 0 0 1-.1.22.83.83 0 0 1-.2.2c-.08.06-.18.1-.29.14-.1.04-.22.05-.36.05Z"
      />
      <rect
        width={25.16}
        height={6.22}
        x={284}
        y={107.76}
        fill={templateStyles['userBackground']}
        rx={3.11}
      />
      <path
        fill={templateStyles['icon']}
        d="M287.34 113.26c-1.1 0-1.8-.69-1.8-1.77 0-1.06.72-1.78 1.76-1.78 1.01 0 1.71.65 1.71 1.57 0 .7-.31 1.13-.8 1.13-.24 0-.43-.14-.46-.34v-.02h-.04a.54.54 0 0 1-.53.34c-.44 0-.74-.36-.74-.9 0-.52.3-.88.74-.88.22 0 .41.11.5.3h.03v-.26h.32v1.25c0 .15.09.23.24.23.27 0 .44-.33.44-.85 0-.77-.58-1.3-1.43-1.3-.83 0-1.43.63-1.43 1.52 0 .9.58 1.5 1.5 1.5.29 0 .57-.05.7-.11v.27c-.18.06-.44.1-.7.1Zm-.11-1.17c.29 0 .47-.23.47-.6 0-.36-.18-.59-.47-.59-.28 0-.45.22-.45.6 0 .37.17.6.45.6Z"
      />
      <path
        fill={templateStyles['fontColor']}
        d="M290.5 112.38v-.34h.94c.23 0 .4-.05.53-.14.12-.1.18-.23.18-.4a.5.5 0 0 0-.09-.3.5.5 0 0 0-.25-.18 1.2 1.2 0 0 0-.4-.06h-.92v-.33h.8c.24 0 .41-.04.53-.12.12-.09.18-.2.18-.37a.44.44 0 0 0-.16-.37.68.68 0 0 0-.44-.13h-.9v-.33h.98c.19 0 .35.03.48.09a.7.7 0 0 1 .43.67c0 .11-.03.21-.08.3a.7.7 0 0 1-.19.24.6.6 0 0 1-.26.12v.04c.13.02.26.06.36.12a.75.75 0 0 1 .32.62.8.8 0 0 1-.48.76c-.16.07-.34.1-.56.1h-1Zm-.2 0v-3.07h.38v3.06h-.38Zm2.82 0v-2.3h.37v.34h.03a.55.55 0 0 1 .23-.28c.1-.06.23-.1.38-.1a.9.9 0 0 1 .1 0l.09.02v.36a1.13 1.13 0 0 0-.23-.03.67.67 0 0 0-.31.08.53.53 0 0 0-.21.2.56.56 0 0 0-.08.28v1.42h-.37Zm1.67 0v-2.3h.37v2.3h-.37Zm.18-2.74a.25.25 0 0 1-.18-.07.25.25 0 0 1-.07-.18c0-.08.02-.14.07-.19a.25.25 0 0 1 .18-.07c.07 0 .13.03.18.08.05.04.08.1.08.18a.25.25 0 0 1-.26.25Zm1.51 2.78a.9.9 0 0 1-.39-.09.68.68 0 0 1-.27-.23.64.64 0 0 1-.1-.36c0-.14.03-.26.1-.36.06-.1.16-.17.28-.23.13-.05.28-.09.45-.1l.84-.05v.3l-.8.05a.69.69 0 0 0-.38.1.31.31 0 0 0-.11.27c0 .12.04.21.13.28.08.06.2.1.33.1s.24-.03.33-.08c.1-.05.18-.12.24-.2a.52.52 0 0 0 .08-.3v-.71c0-.15-.04-.25-.13-.33-.08-.07-.21-.11-.38-.11a.7.7 0 0 0-.34.07.36.36 0 0 0-.18.21h-.37a.6.6 0 0 1 .15-.32.8.8 0 0 1 .31-.21c.13-.05.28-.08.44-.08.19 0 .34.03.47.1.13.05.23.14.3.26.07.11.1.25.1.4v1.58h-.37v-.34h-.03a.74.74 0 0 1-.4.34.9.9 0 0 1-.3.04Zm1.78-.05v-2.29h.37v.35h.03a.64.64 0 0 1 .25-.29c.11-.06.25-.1.42-.1.26 0 .45.08.6.22.13.15.2.36.2.63v1.48h-.37v-1.39c0-.2-.04-.36-.13-.46-.09-.1-.22-.15-.4-.15a.61.61 0 0 0-.32.08.53.53 0 0 0-.21.22.77.77 0 0 0-.07.35v1.36h-.37Zm3.81 0v-3.06h.38v2.72h1.49v.34h-1.87Zm2.44 0v-2.29h.37v2.3h-.37Zm.19-2.73a.25.25 0 0 1-.26-.26c0-.07.03-.13.07-.17a.25.25 0 0 1 .19-.08c.07 0 .13.03.18.08.05.04.07.1.07.18a.25.25 0 0 1-.25.26Zm.88 2.73v-2.29h.37v.35h.03a.64.64 0 0 1 .25-.29c.11-.06.25-.1.42-.1.26 0 .45.08.6.22.13.15.2.36.2.63v1.48h-.37v-1.39c0-.2-.04-.36-.13-.46-.09-.1-.22-.15-.4-.15a.61.61 0 0 0-.32.08.54.54 0 0 0-.21.22.77.77 0 0 0-.07.35v1.36h-.37Z"
      />
    </svg>
  );
};
export default MeetingNotes;
